module.exports = __webpack_public_path__ + "static/media/work6.fd0259f0.jpg";